import * as React from "react";
import { TableBody, TableHeader } from "@david.kucsai/react-pdf-table";
import { View } from "@react-pdf/renderer";

export class TablePdf extends React.PureComponent<> {
  render() {
    let tableHeader = null;
    let tableBody = null;
    let tableFooter = null;

    React.Children.forEach(this.props.children, (c) => {
      if (c.type === TableHeader) {
        if (tableHeader == null) {
          tableHeader = c;
        } else {
          tableFooter = c;
        }
      } else if (c.type === TableBody) {
        tableBody = React.cloneElement(c, {
          data: c.props.data ?? this.props.data ?? [],
        });
      }
    });

    return (
      <View
        style={{
          width: "100%",
        }}
      >
        {tableHeader}
        {tableBody}
        {tableFooter}
      </View>
    );
  }
}
